import { Stack, Avatar, Paper, Typography, Box } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';

import './CustomerSupportChatMessage.scss';

type Props = {
	name?: React.ReactNode | string;
	image?: string;
	icon?: React.ReactNode;
	children: React.ReactNode;
	right?: boolean;
};

const CustomerSupportChatMessage = observer(
	class CustomerSupportChatMessage extends React.Component<Props> {
		renderDesktop() {
			const { name, image, icon, children, right } = this.props;
			return (
				<Stack direction={right ? 'row-reverse' : 'row'} spacing={2} className="customer-support-chat-message">
					<Stack direction="column" alignItems="center" justifyContent="flex-start">
						<Avatar src={image}>{image ?? icon}</Avatar>
						<Typography variant="caption">{name}</Typography>
					</Stack>
					<Paper
						elevation={2}
						sx={{ padding: '0 1rem', background: right ? '#aae3f6' : 'aliceblue' }}
						className="message-content"
					>
						{children}
					</Paper>
				</Stack>
			);
		}

		renderMobile() {
			const { name, image, icon, children, right } = this.props;
			return (
				<Stack direction="column" spacing={1} className="customer-support-chat-message">
					<Stack direction={right ? 'row-reverse' : 'row'} alignItems="center" justifyContent={'flex-start'}>
						{!right && (
							<Avatar src={image} sx={{ width: 32, height: 32 }}>
								{image ?? icon}
							</Avatar>
						)}

						<Typography variant="caption" sx={{ margin: '0 0.5rem' }}>
							{name}
						</Typography>
					</Stack>
					<Box
						sx={{
							display: 'flex',
							justifyContent: right ? 'flex-end' : 'flex-start',
							marginTop: '0',
						}}
					>
						<Paper
							elevation={2}
							sx={{
								padding: '0 1rem',
								background: right ? '#aae3f6' : 'aliceblue',
								display: 'flex',
								flexShrink: 1,
								width: 'fit-content',
								height: 'fit-content',
								borderRadius: '1rem',
								borderTopLeftRadius: right ? '1rem' : '0',
								borderTopRightRadius: right ? '0' : '1rem',
							}}
							className="message-content"
						>
							{children}
						</Paper>
					</Box>
				</Stack>
			);
		}

		render() {
			if (window.innerWidth > 600) {
				return this.renderDesktop();
			} else {
				return this.renderMobile();
			}
		}
	}
);

export default CustomerSupportChatMessage;
